import { render } from "./SelecionarRelatorioPainelVendas.vue?vue&type=template&id=7931ef96&scoped=true&ts=true"
import script from "./SelecionarRelatorioPainelVendas.vue?vue&type=script&lang=ts"
export * from "./SelecionarRelatorioPainelVendas.vue?vue&type=script&lang=ts"

import "./SelecionarRelatorioPainelVendas.vue?vue&type=style&index=0&id=7931ef96&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7931ef96"]])

export default __exports__